import { ScrollableAlert } from '@applyonline/shared/components'
import { t } from '@if/core/i18n'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const CameraPermissionPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [showAlert, setShowAlert] = useState(false)

  useEffect(() => {
    const checkCameraAccess = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true })
        stream.getTracks().forEach((track) => track.stop())
        navigate(`/creditApplication/${id}`, { replace: true })
      } catch {
        // Reste sur la page si l'accès échoue
      }
    }

    void checkCameraAccess()
  }, [id, navigate])

  const requestCameraAccess = async () => {
    try {
      const permission = await navigator.permissions.query({ name: 'camera' as PermissionName })

      if (permission.state === 'denied') {
        setShowAlert(true)
        return
      }

      const stream = await navigator.mediaDevices.getUserMedia({ video: true })
      stream.getTracks().forEach((track) => track.stop())
      navigate(`/creditApplication/${id}`, { replace: true })
    } catch (err) {
      console.error('Camera access denied or error:', err)
      setShowAlert(true)
    }
  }

  return (
    <main className="step-0">
      {showAlert && (
        <ScrollableAlert type="warn" showAlert={showAlert} message={t('vouched.cameraPermission.stillNoPermission')} />
      )}

      <h4 style={{ marginTop: '5rem', marginBottom: '2rem' }}>{t('vouched.cameraPermission.noPermission')}</h4>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <button
          type="button"
          className="btn btn-blue btn primary-action-btn"
          style={{
            marginTop: 0,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
          onClick={requestCameraAccess}
        >
          {t('vouched.cameraPermission.button')}
        </button>
      </div>
    </main>
  )
}

export default CameraPermissionPage
